import React, { Component } from 'react';
import PropTypes from 'prop-types';
import withStyles from 'isomorphic-style-loader/lib/withStyles';
import ContentWrapper from '../../ContentWrapper/ContentWrapper';
// import CommonVideoCard from '../CommonVideoCard/CommonVideoCard';
// external-global styles must be imported in your JS.
import s from './CardScroll.css';

class CardScroll extends Component {
  static propTypes = {
    children: PropTypes.string.isRequired,
    title: PropTypes.string.isRequired
  };
  render() {
    const { children, title, height } = this.props;
    const heightWrapper = height;

    let plainStyle = {
      // height: `${heightWrapper}px`
      height: `${heightWrapper}`
    };

    if (this.props.styleContainer) {
      plainStyle = Object.assign(plainStyle, this.props.styleContainer);
    }

    return (
      <div className={s.cardScroll__wrapper} style={plainStyle}>
        {title && (
          <div className={s.title_container}>
            <h1>{title}</h1>
          </div>
        )}
        <div className={s.main_container} style={{ height: `${height}px` }}>
          <div className={s.shadow} />
          <ContentWrapper myClass="padding">
            <div className={s.main__container_wraper}>{children}</div>
          </ContentWrapper>
        </div>
      </div>
    );
  }
}

export default withStyles(s)(CardScroll);
